import FormMultiTextInputField from "shared/form/fields/multiTextInputField";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import DynamicFieldLabel from "./DynamicFieldLabel";

export default function EmailListFieldWrapper(props: DynamicFieldConfigType) {
  return (
    <FormMultiTextInputField
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      disabled={props.schemaObj.disabled}
      required={props.schemaObj.mandatory}
      validate={props.validationFn}
      placeholder={props.schemaObj.placeholderLabel}
      conflictValue={props.schemaObj.conflictValue}
      fullWidth={props.schemaObj.fullWidthView}
      indented={props.schemaObj.indented}
    />
  );
}
